import React from 'react'
import PropTypes from 'prop-types'
import { InView } from 'react-intersection-observer'

const InViewSection = ({ threshold, children }) => (
  <InView triggerOnce={true} threshold={threshold}>
    {({ inView, ref }) => (
      <div ref={ref} data-inview={inView.toString()}>
        {React.cloneElement(children, { inView: inView })}
      </div>
    )}
  </InView>
)

InViewSection.propTypes = {
  threshold: PropTypes.number,
  children: PropTypes.node.isRequired,
}

InViewSection.defaultProps = {
  threshold: 0.2,
}

export default InViewSection
